<template functional>
    <div class="filter-label">
        <VLabel
            @click="listeners.click('')"
            @mouseover="listeners.mouseover($event)"
        >
            <slot></slot>
            <span
                v-if="props.changes"
                :class="[typeof props.changes === 'string' || (typeof props.changes === 'number' &&
                    props.changes >= 0) ? 'filter-label_positive' : 'filter-label_negative']"
            >({{ props.changes }})</span>
        </VLabel>
    </div>
</template>

<script>
    export default {
        name: 'FilterLabel',
        props: {
            changes: {
                type: [Number, String],
                required: false,
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .filter-label {
        cursor: pointer;
        ::v-deep span{
            pointer-events: none;
        }
        
        ::v-deep .VLabel {
            display: inline-block;
            cursor: pointer;
            position: relative;
            padding-left: 20px;
            text-transform: capitalize;
            font-weight: 600;
        
            &-action {
                display: inline-block;
                font-size: 15px;
                line-height: 0;
                font-weight: bold;
                position: absolute;
                top: 2px;
                left: 7px;
            }
            
        }
        &_positive {
            color: $dark-blue-color;
        }
        
        &_negative {
            color: $dark-blue-color;
        }
    }
</style>